// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"04ba7b52","115":"3c2d9d0e","453":"bb828c5d","463":"b0ba70cf"}[chunkId] + ".chunk.js";
};